import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Curso from "./curso";
import Contact from "../Contact/contact";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import SlowMotionVideoIcon from "@mui/icons-material/SlowMotionVideo";
import School from "@mui/icons-material/School";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import ImportantDevicesIcon from "@mui/icons-material/ImportantDevices";
import Camera from "@mui/icons-material/OndemandVideoOutlined";
import TagFacesIcon from "@mui/icons-material/TagFacesTwoTone";
import Typography from "@mui/material/Typography";
import WatchLaterIcon from "@mui/icons-material/WatchLater";
import LinearProgress from "@mui/material/LinearProgress";
import { obtenerCursos } from "../Services/cursosServices";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Skeleton from "@mui/material/Skeleton";
import { Divider } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Review from "../Review/review";
//import ReactGA from "react-ga4";

const useStyles = makeStyles({
  root: {
    maxWidth: 345,
    margin: "auto",
  },
});

const Cursos = () => {
  const [cursos, setCursos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cupon, setCupon] = useState("");
  const [cuponv, setCuponv] = useState(false);

  const history = useNavigate();

  useEffect(() => {
    //ReactGA.send("/cursos");
    window.scrollTo(0, 0);
    cargarCursos();
  }, []);

  const cargarCursos = async () => {
    const { data: cursos } = await obtenerCursos();
    console.log(cursos);
    setCursos(cursos);
    setLoading(false);
    setCupon(cursos[0].cupon);
  };

  let hoy = new Date();

  const classes = useStyles();

  return (
    <>
      {loading && <LinearProgress />}

      <div className="main-bg6">
        <div className="main-title5">
          <h1>
            CURSOS DESTACADOS
            <Camera
              sx={{ fontSize: 70, color: "#FFF", verticalAlign: "middle" }}
            />
          </h1>
        </div>
      </div>

      {loading && (
        <Container maxWidth="sm xs lg" sx={{ p: 2, backgroundColor: "f6f6f6" }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4} lg={4}>
              <Box className={classes.root}>
                <Skeleton width="100%" height={150}></Skeleton>
                <Skeleton width="90%" height={30}></Skeleton>
                <Skeleton width="70%" height={30}></Skeleton>
                <Skeleton width="50%" height={30}></Skeleton>
              </Box>
            </Grid>
            <Grid item xs={12} sm={4} lg={4}>
              <Box className={classes.root}>
                <Skeleton width="100%" height={150}></Skeleton>
                <Skeleton width="90%" height={30}></Skeleton>
                <Skeleton width="70%" height={30}></Skeleton>
                <Skeleton width="50%" height={30}></Skeleton>
              </Box>
            </Grid>
            <Grid item xs={12} sm={4} lg={4}>
              <Box className={classes.root}>
                <Skeleton width="100%" height={150}></Skeleton>
                <Skeleton width="90%" height={30}></Skeleton>
                <Skeleton width="70%" height={30}></Skeleton>
                <Skeleton width="50%" height={30}></Skeleton>
              </Box>
            </Grid>
          </Grid>
        </Container>
      )}

      <Container
        maxWidth="false"
        sx={{ maxWidth: "90%", p: 4, backgroundColor: "#f6f6f6" }}
      >
        <Box>
          <Grid container spacing={5}>
            {cursos.map((curso) => (
              <Curso curso={curso} key={curso.idCurso}></Curso>
            ))}
          </Grid>
        </Box>
        <br />
        <br />
        <br />
      </Container>

      <Container maxWidth="sm xs lg" sx={{ backgroundColor: "white" }}>
        <Grid container spacing={3}>
          <Grid item sm>
            <Box className="main-title3">
              <p className="text-main3">Enseñamos en Udemy.com</p>
              <p className="subtext-main3">
                Nuestra plataforma estratégica de aprendizaje.
              </p>
              <img src="images/udemy.png" width="200" />
              <br />
              <Button
                type="submit"
                variant="contained"
                color="secondary"
                size="large"
                target="_blank"
                href="https://www.udemy.com"
              >
                saber más
              </Button>
            </Box>
          </Grid>
          <Grid item sm>
            <img src="images/main_bg5.jpg" width="80%" />
          </Grid>
        </Grid>
        <br />
        <br />
        <br />
        <br />
      </Container>
      <Contact />
    </>
  );
};

export default Cursos;
